module.exports = __webpack_public_path__ + "img/kkb_uvbar.232f49a5.jpg";